import { Middleware } from '@reduxjs/toolkit';
import { checkSessionTimeout } from '../slices/registrationSlice';

let timeoutId: NodeJS.Timeout;
let lastActivityTime = Date.now();

// Only track user activity actions to reduce middleware overhead
const USER_ACTIVITY_ACTIONS = [
  'auth/login/fulfilled',
  'auth/refreshToken/fulfilled',
  'kyt/validateAddress/fulfilled',
  'kyt/analyzeAddress/fulfilled',
  'kyt/traceTransactions/fulfilled',
  'transactions/fetchData/fulfilled',
  'dashboard/fetchData/fulfilled'
];

export const sessionTimeoutMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);
  
  // Only process session timeout for user activity actions
  if (action && typeof action === 'object' && 'type' in action && 
      typeof action.type === 'string' && USER_ACTIVITY_ACTIONS.includes(action.type)) {
    lastActivityTime = Date.now();
    
    // Clear existing timeout
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Set new timeout with debouncing
    timeoutId = setTimeout(() => {
      // Only check if enough time has passed since last activity
      if (Date.now() - lastActivityTime >= 60000) {
        store.dispatch(checkSessionTimeout());
      }
    }, 60000); // Check every minute
  }

  return result;
}; 